import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {APIResponse} from '@core/interfaces/system/system-common';
import {
    RulesService,
    CheckRuleNameExistsRequest,
    FieldDto,
    FieldRequest,
    FullRuleDto,
    Rule,
    RuleDiscriminator,
    RuleField,
    RuleFilterOptionResult,
    RuleType,
} from '@core/interfaces/engin/inspection-rules/rules';
import {RulesApi} from '@core/backend/engin/api/inspection-rules/rules.api';

@Injectable({
    providedIn: 'root',
})
export class RulesServiceImpl extends RulesService {
    constructor(private api: RulesApi) {
        super();
    }

    // auto-approve inspection
    checkExistingRuleName(req: CheckRuleNameExistsRequest): Observable<APIResponse<boolean>> {
        return this.api.checkExistingRuleName(req);
    }

    createRule(rule: FullRuleDto): Observable<APIResponse<FullRuleDto>> {
        return this.api.createRule(rule);
    }

    deleteRuleById(ruleId: number): Observable<APIResponse<Rule>> {
        return this.api.deleteRuleById(ruleId);
    }

    duplicateRuleById(ruleId: number): Observable<APIResponse<FullRuleDto>> {
        return this.api.duplicateRuleById(ruleId);
    }

    editRuleById(rule: FullRuleDto): Observable<APIResponse<FullRuleDto>> {
        return this.api.editRuleById(rule);
    }

    executeRuleById(ruleId: number): Observable<APIResponse<boolean>> {
        return this.api.executeRuleById(ruleId);
    }

    toggleRuleStatus(ruleId: number, activeMode: boolean): Observable<APIResponse<any>> {
        return this.api.executeAutoRuleById(ruleId, activeMode);
    }

    getFieldNameListByType(req: FieldRequest): Observable<APIResponse<FieldDto[]>> {
        return this.api.getFieldNameListByType(req);
    }

    getFieldTypeList(): Observable<APIResponse<RuleField[]>> {
        return this.api.getFieldTypeList();
    }

    getFieldValueListByName(param: FieldRequest): Observable<APIResponse<RuleFilterOptionResult[]>> {
        return this.api.getFieldValueListByName(param);
    }

    getInspectionNameList(ruleType: RuleType): Observable<APIResponse<FieldDto[]>> {
        return this.api.getInspectionNameList(ruleType);
    }

    getInspectionValueListByName(param: FieldRequest): Observable<APIResponse<any[]>> {
        return this.api.getInspectionValueListByName(param);
    }

    getResultAffectedByRule(rule: FullRuleDto): Observable<APIResponse<number>> {
        return this.api.getResultAffectedByRule(rule);
    }

    getRuleById(ruleId: number): Observable<APIResponse<FullRuleDto>> {
        return this.api.getRuleById(ruleId);
    }

    getRuleList(applyTo: RuleDiscriminator): Observable<APIResponse<Rule[]>> {
        return this.api.getRuleList(applyTo);
    }

    updateRuleListOrder(ruleList: Rule[]): Observable<APIResponse<boolean>> {
        return this.api.updateRuleListOrder(ruleList);
    }
}
